// eslint-disable-next-line no-unused-vars
import React from 'react';
import { Outlet } from 'react-router-dom';

import Header from 'Containers/Header/Header';
import Footer from 'Containers/Footer/Footer';

const App = () => (
  <>
    <Header />
    <Outlet />
    <Footer />
  </>
);

export default App;
